import { quickOrderSearchStyles as styles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderSearch";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.productSelector = {
    ...styles.productSelector,
    container: {
        gap: 10,
        css: css`
            align-items: flex-end;
        `,
        offsetCss: css`
            display: flex;
            flex-direction: column;

            justify-content: center;

            ${mediaQueriesBP.minMD} {
                flex-direction: row;
                align-items: flex-end;
                justify-content: flex-start;
            }
        `,
    },
    searchGridItem: {
        width: [12, 12, 4, 6, 5],
        css: css`
            position: relative;
        `,
    },

    qtyGridItem: {
        width: [4, 4, 2, 1, 1],
    },
    unitOfMeasureGridItem: {
        width: [4, 4, 3, 1, 1],
    },
    buttonGridItem: {
        width: [6, 6, 3, 2, 2],
        css: css`
            ${mediaQueriesBP.minMD} {
                margin-inline-start: auto !important;
                justify-content: flex-end;
            }
        `,
    },
    selectButton: {
        css: css`
            margin: 10px 0 0;
            ${mediaQueriesBP.minMD} {
                margin: auto 0 0;
            }
        `,
    },
};
